import { SectionContainer, SectionTitle } from "screens/Homepage/styles";
import BuildingBlock from "./BuildingBlock";
import Blocks from "./data";

interface IProps {}

const BuildingBlocks: React.FC<IProps> = () => {
  return (
    <SectionContainer>
      <SectionTitle>We help AI teams ship faster</SectionTitle>
      {Blocks.map((block, key) => (
        <BuildingBlock key={key} {...block} />
      ))}
    </SectionContainer>
  );
};

export default BuildingBlocks;
